<template>
    <div>
        <div class="home-hero-wrapper">
            <Navbar />
            <MainBanner />
        </div>
        <Feature />
        <About />
        <AboutReverse />
        <About2 />
        <AboutReverse2 />
        <!-- <Services /> -->
        <Process />
        <FreeTrial variant="dark"/>
        <Client />
        <!-- <Testimonial /> -->
        <Blog class="bg-linear-gradient" />
        <FreeTrial variant="light"/>
        <LinkBanner />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import MainBanner from '../HomeOne/MainBanner'
import Feature from '../HomeOne/Feature'
import About from '../Common/About'
import About2 from '../Common/About2'
import AboutReverse from '../Common/AboutReverse'
import AboutReverse2 from '../Common/AboutReverse2'
// import Services from '../Common/Services'
import FreeTrial from '../Common/FreeTrial'
import Process from '../HomeOne/Process'
import Client from '../HomeOne/Client'
// import Testimonial from '../HomeOne/Testimonial'
import Blog from '../Common/Blog'
// import Newsletter from '../Common/Newsletter'
import LinkBanner from '../Common/LinkBanner'
import Footer from '../Layout/Footer'

export default {
    name: 'HomePageOne',
    components: {
        Navbar,
        MainBanner,
        Feature,
        About,
        About2,
        AboutReverse,
        AboutReverse2,
        // Services,
        FreeTrial,
        Process,
        Client,
        // Testimonial,
        Blog,
        // Newsletter,
        LinkBanner,
        Footer,
    },
    computed: {
        homeHeroBackground() {
            return `url(${this.$ossImg('home-about/banner.jpg')})`
        }
    }
}
</script>
<style scoped>
.bg-linear-gradient {
    background: linear-gradient(137deg, #FCF5FF 3.23%, #F2F9FE 83.93%);
}

.home-hero-wrapper {
    background-image: v-bind('homeHeroBackground');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
}
</style>
